import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextNavComponent } from './context-nav.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ContextNavComponent],
  exports: [
    ContextNavComponent
  ]
})
export class ContextNavModule { }
